function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Close_Hover",
  transform: "translate(.365)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  className: "background",
  "data-name": "Ellipse 24",
  cx: 20,
  cy: 20,
  r: 20,
  transform: "translate(-.365)",
  fill: "#98c3d9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_797",
  "data-name": "Group 797",
  transform: "rotate(45 4.672 24.935)",
  fill: "none",
  stroke: "#002d56",
  strokeLinecap: "square",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  id: "Line_13",
  "data-name": "Line 13",
  transform: "translate(0 11.314)",
  d: "M0 0h22.627"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_14",
  "data-name": "Line 14",
  transform: "translate(11.314)",
  d: "M0 0v22.627"
})));

function SvgCloseRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0iQ2xvc2VfSG92ZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMzY1KSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzI0IiBjbGFzcz0iYmFja2dyb3VuZCIgZGF0YS1uYW1lPSJFbGxpcHNlIDI0IiBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjM2NSkiIGZpbGw9IiM5OGMzZDkiLz4KICAgIDxnIGlkPSJHcm91cF83OTciIGRhdGEtbmFtZT0iR3JvdXAgNzk3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOSA0KSByb3RhdGUoNDUpIj4KICAgICAgPGxpbmUgaWQ9IkxpbmVfMTMiIGRhdGEtbmFtZT0iTGluZSAxMyIgeDI9IjIyLjYyNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMS4zMTQpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDJkNTYiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgICA8bGluZSBpZD0iTGluZV8xNCIgZGF0YS1uYW1lPSJMaW5lIDE0IiB5Mj0iMjIuNjI3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMS4zMTQgMCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMmQ1NiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };